import { WindowKind, instanceId, useDesktop } from "@/overlay/components";
import type { AdvancedThreshold } from "@/overlay/components/CommonParts/Threshold/types";
import { useCallback } from "react";

export const useThresholdManager = (
  advancedThresholds: AdvancedThreshold[],
  onThresholdChange: (newThresholds: AdvancedThreshold[]) => void,
  isPoi?: boolean,
) => {
  const desktop = useDesktop();
  const openThresholdManager = useCallback(() => {
    desktop.dispatch({
      type: "confirmationWindow",
      windowId: instanceId(WindowKind.ThresholdManagerWindow),
      customProps: {
        onUpdate: onThresholdChange,
        advancedThresholds: advancedThresholds,
        isPoi,
      },
    });
  }, [desktop, advancedThresholds, onThresholdChange]);

  return openThresholdManager;
};
